import { ApplicationState } from '../..';

export const agendaState = (state: ApplicationState) => state.details.detailsAgenda;
export const instructionId = (state: ApplicationState) => state.caseState.selectedCase.instructionId;
